import { useState, useContext } from "react";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";

const useImageDeletion = () => {
  const [deleting, setDeleting] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const {token} = useContext(AuthContext)

  const deleteImages = async (vesselId, imagesToDelete) => {
    try {
      setDeleting(true);
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vessel/delete/images/${vesselId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ images: imagesToDelete }),
      });

      if (!response.ok) {
        throw new Error("Failed to delete images.");
      }

      toast.success("Images deleted successfully.");
      setSelectedImages([]); 
      setDeleting(false);
    } catch (error) {
      toast.error(error.message || "An error occurred while deleting images.");
      setDeleting(false);
    }
  };

  return { deleting, selectedImages, setSelectedImages, deleteImages };
};

export default useImageDeletion;
